import script from "./SocialSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialSection.vue?vue&type=script&setup=true&lang=js"

import "./SocialSection.vue?vue&type=style&index=0&id=bbfd1c66&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbfd1c66"]])

export default __exports__